// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --height-images: 150px;
  display: block;
  width: 290px;
  scroll-snap-align: start;
  background-color: var(--color-surface);
  border-radius: 10px;
  border: 1.5px solid #E4E4E4;
  overflow: hidden;
}
:host .clinic-images {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 2fr 1fr;
  grid-gap: var(--space-xs);
  position: relative;
  height: var(--height-images);
  width: 100%;
}
:host .clinic-images.equal {
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
}
:host .clinic-images > img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
:host .clinic-images > img:nth-of-type(1) {
  grid-row: span 2;
  grid-column: 1;
}
:host .clinic-images > img:nth-of-type(2) {
  grid-row: 1;
  grid-column: 2;
}
:host .clinic-images > img:nth-of-type(3) {
  grid-row: 2;
  grid-column: 2;
}
:host .clinic-images > img.unique {
  grid-row: span 2;
  grid-column: span 2;
}
:host .clinic-images > img.dual {
  grid-row: 1/span 2;
}
:host .clinic-images ::ng-deep app-checkbox {
  position: absolute;
  display: block;
  width: 35px;
  top: var(--space-md);
  left: var(--space-md);
}
:host .clinic-images ::ng-deep app-checkbox .checkbox-icon {
  box-shadow: 0 0 0 1px var(--ion-color-secondary) !important;
  background-color: var(--ion-color-secondary) !important;
}
:host .clinic-body {
  min-height: 95px;
  padding: 13px 20px 20px 20px;
  text-align: left;
}
:host .clinic-body .header {
  font-weight: 700;
  font-size: var(--font-size-lg);
  color: var(--ion-color-black);
}
:host .clinic-body .address {
  display: flex;
  align-items: center;
  font-size: var(--font-size-sm);
}
:host .clinic-body .address .icon {
  margin-right: var(--space-xs);
  font-size: var(--font-size-xl);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/clinic-preview/clinic-preview.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EAEA,cAAA;EACA,YAAA;EACA,wBAAA;EACA,sCAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAAJ;AAEI;EACI,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;EAEA,kBAAA;EACA,4BAAA;EACA,WAAA;AADR;AAGQ;EACI,2BAAA;EACA,8BAAA;AADZ;AAIQ;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AAFZ;AAIY;EACI,gBAAA;EACA,cAAA;AAFhB;AAKY;EACI,WAAA;EACA,cAAA;AAHhB;AAMY;EACI,WAAA;EACA,cAAA;AAJhB;AAOY;EACI,gBAAA;EACA,mBAAA;AALhB;AAQY;EACI,kBAAA;AANhB;AAUQ;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AARZ;AASY;EACI,2DAAA;EACA,uDAAA;AAPhB;AAaI;EACI,gBAAA;EACA,4BAAA;EACA,gBAAA;AAXR;AAaQ;EACI,gBAAA;EACA,8BAAA;EACA,6BAAA;AAXZ;AAcQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAZZ;AAcY;EACI,6BAAA;EACA,8BAAA;AAZhB","sourcesContent":[":host{\r\n    --height-images: 150px;\r\n\r\n    display: block;\r\n    width: 290px;\r\n    scroll-snap-align: start;\r\n    background-color: var(--color-surface);\r\n    border-radius: 10px;\r\n    border: 1.5px solid #E4E4E4;\r\n    overflow: hidden; // Prevent images overflow item\r\n\r\n    .clinic-images {\r\n        display: grid;\r\n        grid-template-rows: 1fr 1fr;\r\n        grid-template-columns: 2fr 1fr;\r\n        grid-gap: var(--space-xs);\r\n\r\n        position: relative;\r\n        height: var(--height-images);\r\n        width: 100%;\r\n\r\n        &.equal {\r\n            grid-template-rows: 1fr 1fr;\r\n            grid-template-columns: 1fr 1fr;\r\n        }\r\n\r\n        > img {\r\n            height: 100%;\r\n            width: 100%;\r\n            object-fit: cover;\r\n\r\n            &:nth-of-type(1) {\r\n                grid-row: span 2;\r\n                grid-column: 1;\r\n            }\r\n\r\n            &:nth-of-type(2) {\r\n                grid-row: 1;\r\n                grid-column: 2;\r\n            }\r\n\r\n            &:nth-of-type(3) {\r\n                grid-row: 2;\r\n                grid-column: 2;\r\n            }\r\n\r\n            &.unique {\r\n                grid-row: span 2;\r\n                grid-column: span 2;\r\n            }\r\n\r\n            &.dual {\r\n                grid-row: 1 / span 2;\r\n            }\r\n        }\r\n\r\n        ::ng-deep app-checkbox{\r\n            position: absolute;\r\n            display: block;\r\n            width: 35px;\r\n            top: var(--space-md);\r\n            left: var(--space-md);\r\n            .checkbox-icon {\r\n                box-shadow: 0 0 0 1px var(--ion-color-secondary) !important;\r\n                background-color: var(--ion-color-secondary) !important;\r\n            }\r\n        }\r\n        \r\n    }\r\n\r\n    .clinic-body{\r\n        min-height: 95px;\r\n        padding: 13px 20px 20px 20px;\r\n        text-align: left;\r\n\r\n        .header{\r\n            font-weight: 700;\r\n            font-size: var(--font-size-lg);\r\n            color: var(--ion-color-black);\r\n        }\r\n\r\n        .address {\r\n            display: flex;\r\n            align-items: center;\r\n            font-size: var(--font-size-sm);\r\n\r\n            .icon {\r\n                margin-right: var(--space-xs);\r\n                font-size: var(--font-size-xl);\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
